import { Component, OnInit, OnDestroy, ViewChild, Output, EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Subscription, timer } from 'rxjs';
import { CounterService } from 'src/app/_services/counter.service';
import { ImportService } from 'src/app/_services/import.service';
import { Imports } from 'src/app/_models/import';
import { SuccessEvent, UploadEvent, FileRestrictions } from '@progress/kendo-angular-upload';
import { NotifyService } from 'src/app/_services/notify.service';
import { Counter } from 'src/app/_models/counter';
import { Import2Service } from 'src/app/_services/import2.service';

@Component({
   selector: 'app-import2',
   templateUrl: './import2.component.html',
   styleUrls: ['./import2.component.scss'],
})
export class Import2Component implements OnInit, OnDestroy {
   public opened = false;
   selectedImport: Imports;
   baseUrl = environment.apiUrl;
   public uploadSaveUrl = '';
   UploadValue = 0;
   UploadType = '';
   AMSTimer: any;
   errorList: string[] = [];
   IsError = false;
   private timerSubscription: Subscription;
   @Output()
   dialogClose: EventEmitter<boolean> = new EventEmitter<boolean>();
   private Importubscription: Subscription;

   fileRestrictions: FileRestrictions = {
      allowedExtensions: ['.xls', '.xlsx'],
      maxFileSize: 50 * 1024 * 1024,
   };
   constructor(private import2Service: Import2Service, private counterService: CounterService, private notify: NotifyService) {}

   ngOnInit() {
      this.Importubscription = this.import2Service.ImportSelected.subscribe((importObj: Imports) => {
         this.selectedImport = importObj;
         (this.uploadSaveUrl = this.baseUrl + this.selectedImport.url + '/import'), (this.opened = true);
      });
   }
   ngOnDestroy() {
      this.Importubscription.unsubscribe();
   }
   closeDialog() {
      this.opened = false;
      this.dialogClose.emit(null);
      this.IsError = false;
      this.errorList = [];
      this.UploadType = '';
   }

   successEventHandler(e: SuccessEvent) {
      if (e.response) {
         this.UploadValue = 100;
         this.timerSubscription?.unsubscribe();
         this.UploadValue = 0;
         this.closeDialog();
         const message = 'Successfully uploaded';
         this.notify.success(message);
         this.IsError = false;
         this.errorList = [];
         this.UploadType = '';
      }
   }
   errorEventHandler(e: any) {
      this.timerSubscription?.unsubscribe();
      this.IsError = true;
      const payload = e?.response?.error ?? e?.response ?? e;
      this.errorList = this.normalizeErrors(payload);

      this.UploadValue = 0;
      this.UploadType = '';
   }
   uploadEventHandler(e: UploadEvent) {
      this.errorList = [];
      this.IsError = false;
      e.headers = e.headers.append('Authorization', 'Bearer ' + localStorage.getItem('token'));

      e.data = {
         description: 'Upload',
         File: e.files[0].rawFile,
      };
      this.UploadType = 'Warming up...';
      this.UploadValue = 1;
      this.AMSTimer = timer(3000, 3000);
      this.timerSubscription = this.AMSTimer.subscribe((t) => {
         this.counterService.getCounter(this.selectedImport.module).subscribe((counter: Counter) => {
            this.UploadType = counter.importType;
            this.UploadValue = +counter.value;
         });
      });
   }

   public close() {
      this.opened = false;
      this.IsError = false;
      this.UploadType = '';
   }

   private normalizeErrors(value: any): string[] {
      if (value == null) {
         return ['An unknown error occurred.'];
      }

      if (Array.isArray(value)) {
         const flattened = (value as any[]).reduce((acc: string[], v: any) => {
            return acc.concat(this.normalizeErrors(v));
         }, []);

         return flattened
            .map((v) => (typeof v === 'string' ? v.trim() : String(v)))
            .filter((v) => v.length > 0);
      }

      if (typeof value === 'string' || value instanceof String) {
         return String(value)
            .split(/\r?\n/)
            .map((v) => v.trim())
            .filter((v) => v.length > 0);
      }

      if (typeof value === 'object') {
         const maybeAny = value as any;
         if (Array.isArray(maybeAny.errors)) {
            return this.normalizeErrors(maybeAny.errors);
         }
         if (typeof maybeAny.message === 'string') {
            return this.normalizeErrors(maybeAny.message);
         }
      }

      return [String(value)];
   }
}
